import { Flex } from '@chakra-ui/react';
import { useState } from 'react';
import { useDeliveryInfo } from '~/hooks/resources/delivery_info';
import { SkeletonText } from '../ui/skeleton';
import { ProfileImageForm } from './ProfileImageForm';

export const ProfileImage: React.FC = () => {
  const { icon_image_url, loading } = useDeliveryInfo();
  const [submitting] = useState(false);

  if (loading) return <MeSkeleton />;
  return (
    <ProfileImageForm
      load={loading}
      submitting={submitting}
      url={icon_image_url ?? undefined}
    />
  );
};

const MeSkeleton: React.FC = () => {
  return (
    <Flex
      flex={1}
      flexDir="column"
      maxW="600px"
      w="full"
      justifyContent="center"
      mx={2}
    >
      <Flex px={4} py={4} backgroundColor="disable">
        <SkeletonText lineClamp={1} w={40} />
      </Flex>
      {[...Array(0)].map((_, index) => {
        return (
          <Flex
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            w="full"
            key={index}
          >
            <SkeletonText lineClamp={1} w={80} />
          </Flex>
        );
      })}
    </Flex>
  );
};
